export const STEPS = {
  CSV_UPLOAD: 'csv-upload',
  CSV_MAPPING: 'csv-mapping',
  EMAIL_MARKETING: 'email-marketing',
  ERROR_REPORT: 'error-report',
  SUCCESS_CONFIRMATION: 'success-confirmation',
};
